import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ajustarEscala, iniciarTema } from "./lib/tema.ts";
import "./index.css";

iniciarTema();
ajustarEscala();
createRoot(document.getElementById("raiz")!).render(
  <StrictMode><App /></StrictMode>,
);
